import React, { PureComponent, ReactElement } from "react";
import styled from "styled-components/macro";
import { SIDELIST_TITLE_BACKGROUND, BORDER_COLOR } from "../../helpers/Const";

const SidebarResizerRoot = styled.div`
  flex: 0 0 8px;
  width: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: col-resize;
  border-right: solid 1px ${BORDER_COLOR};
  border-left: solid 1px ${BORDER_COLOR};
  background-color: ${SIDELIST_TITLE_BACKGROUND};
`;

const SidebarResizerInner = styled.div`
  flex: 0 0 auto;
  border-radius: 50%;
  height: 4px;
  width: 4px;
  margin: 3px 0;
  background-color: #fff;
`;

export interface ISidebarResizerProps {
  onTaskListSizing: (delta: number) => void;
}

export default class SidebarResizer extends PureComponent<ISidebarResizerProps> {
  draggingPosition = 0;

  doMouseDown = (e: React.MouseEvent<HTMLElement>): void => {
    if (e.button === 0) {
      this.draggingPosition = e.clientX;
      document.addEventListener("mousemove", this.doMouseMove);
      document.addEventListener("mouseup", this.doMouseUp);
    }
  };

  doMouseMove = (e: MouseEvent): void => {
    const delta = this.draggingPosition - e.clientX;
    this.draggingPosition = e.clientX;
    this.props.onTaskListSizing(delta);
  };

  doMouseUp = (): void => {
    document.removeEventListener("mousemove", this.doMouseMove);
    document.removeEventListener("mouseup", this.doMouseUp);
  };

  render(): ReactElement {
    return (
      <SidebarResizerRoot onMouseDown={this.doMouseDown}>
        <SidebarResizerInner />
        <SidebarResizerInner />
        <SidebarResizerInner />
        <SidebarResizerInner />
      </SidebarResizerRoot>
    );
  }
}
